import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Row } from 'antd';
import moment from 'moment';
import { ButtonEditSummaryItem } from './editSummaryComponents/ButtonEditSummaryItem';
import { LocationComponent } from './LocationComponent';
import { TitleSummary } from '../../style';
import { textfieldTypes } from '../../../../config/constants/mobileFormConstant';

export const TextComponents = ({ field, onEdit }) => {
  const value = useMemo(() => {
    if (!field.value) return field.value;
    const valueHandlers = {
      [textfieldTypes.DATETIME.name]: () => {
        return moment(field.value).format('DD-MM-YYYY HH:mm');
      },
      [textfieldTypes.DATE.name]: () => {
        return moment(field.value).format('DD-MM-YYYY');
      },
      [textfieldTypes.TIME.name]: () => {
        const m = moment(field.value, ['HH:mm', 'H:mm'], true);
        return m.isValid() ? m.format('hh:mm a') : value;
      },
    };
    return valueHandlers[field.typeTextField]?.() ?? field.value;
  }, [field]);

  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary>{field.label}</TitleSummary>
        <Row>
          <p>{field.typeTextField === textfieldTypes.GEOLOCATION.name ? <LocationComponent field={field} /> : value}</p>
          {onEdit != null ? <ButtonEditSummaryItem onClick={onEdit} /> : null}
        </Row>
      </React.Fragment>
    </>
  );
};

TextComponents.propTypes = {
  field: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
};
